module.exports = __webpack_public_path__ + "img/bridge_loader.0fa31ca6.svg";